import React, { useState, useEffect } from "react";
import CustomTable from "../../../../../customComponents/CustomTable";
import searchIcon from "./../../../../../../Assets/icons/searchicon.svg";
import editIcon from "./../../../../../../Assets/icons/Un-Checkbox.svg";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../../../../services/api/API";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import ListLogisticsFilters from "../../../../Logistics/LogisticsFilter";
import Loader from "../../../../../customComponents/CustomLoader";
import { IoMdClose } from "react-icons/io";

const DealerBranchList = () => {
  const [dealerBranches, setDealerBranches] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(true);
  const [totalData, setTotalData] = useState(0);
  const [totalActive, setTotalActive] = useState(0);
  const [totalInactive, setTotalInactive] = useState(0);
  const [revenue, setRevenue] = useState(0);
  const [filterFormData, setFilterFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [totalRecords, setTotalRecords] = useState(0);
  const [city, setCity] = useState([]);
  const navigate = useNavigate();
  const token = localStorage.getItem("authToken");

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    fetchDealerBranches(newPage);
  };

  useEffect(() => {
    fetchCity();
  }, []);

  const fetchCity = async () => {
    try {
      const response = await axiosInstance.post(
        "/showroom/ddlShowroomcity",
        {
          business_partner_id: 1,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = response.data.data.data; // Access the data from the response object
      const cityOptions = data.map((city) => ({
        value: city.ID,
        label: city.NAME,
      }));
      setCity(cityOptions); // Assuming setCity is a state setter function
    } catch (error) {
      console.log(error); // Log the error for debugging purposes
    }
  };

  const fetchDealerBranches = async (page = 0, pageSize = 10) => {
    const allfilteredData = filters;

    try {
      setLoading(true);
      const response = await axiosInstance.post(
        "/showroom/list",
        {
          orderBy: "showroom_id desc",
          page,
          pageSize,
          startDate: allfilteredData?.fromDate
            ? allfilteredData?.fromDate
            : null,
          endDate: allfilteredData?.toDate ? allfilteredData?.toDate : null,
          city_id: allfilteredData?.city ? allfilteredData?.city : null,
          searchText: searchTerm,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const formattedData = response.data.data.data.map((item, index) => ({
        ...item,
        "Sr No.": index + 1,
        state_name:
          item.state_name.charAt(0).toUpperCase() +
          item.state_name.slice(1).toLowerCase(),
        city_name:
          item.city_name.charAt(0).toUpperCase() +
          item.city_name.slice(1).toLowerCase(),
      }));

      const totalRecordsData = response?.data?.data?.totalRecords;

      const totalCount = response?.data?.data?.total;
      const total_active = response?.data?.data?.total_active;
      const unitSold = response?.data?.data?.total_inactive;
      const revenueCount = response?.data?.data?.annual_revenue;

      setTotalData(totalCount);
      setTotalActive(total_active);
      setTotalInactive(unitSold);
      setRevenue(revenueCount);

      console.log(totalRecordsData, "RECORDS");
      setTotalRecords(totalRecordsData);

      setDealerBranches(formattedData);
      setTotalPages(Math.ceil(response?.data?.data?.totalRecords / pageSize));
    } catch (error) {
      console.error("Error fetching dealer branches:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchInputChange = (event) => {
    setSearchTerm(event.target.value);
  };

  useEffect(() => {
    fetchDealerBranches();
  }, []);

  const DEALER_BRANCH_TABLE_HEADERS = [
    // "Sr No.",
    // "Branch ID",
    "Dealer Branch",
    "Contact No",
    "Address",
    "Pincode",
    "City",
    "State",
    "Country",
    "Created Date",
    "Status",
    "Action",
  ];

  const DEALER_BRANCH_KEY_MAPPING = {
    // "Sr No.": "Sr No.",
    // "Branch ID": "showroom_id",
    "Dealer Branch": "showroom_name",
    "Contact No": "contact_no",
    Address: "showroom_address",
    Pincode: "showroom_pincode",
    City: "city_name",
    State: "state_name",
    Country: "country_name",
    "Created Date":"created_at",
    Status: "status",
    Action: [{ type: "edit", icon: editIcon, label: "Edit" }],
  };

  const handleEdit = (rowData) => {
    navigate(`${ROUTES_NAVIGATION.EDITDEALERBRANCH}`, {
      state: { data: rowData },
    });
  };

  const clearFilter = () => {
    setFilterFormData({});
    setFilters({});
    fetchDealerBranches();
  };

  useEffect(() => {
    fetchDealerBranches();
  }, [filters]);

  const handleSearch = () => {
    // Update the filters state with the current form data
    setFilters({
      fromDate: filterFormData.startDate || null,
      toDate: filterFormData.endDate || null,
      city: filterFormData.city_id || null,
    });
  };

  const PhysicalStockTakingInputs = [
    {
      name: "startDate",
      label: "From Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-2",
    },
    {
      name: "endDate",
      label: "To Date",
      type: "date",
      maxDate: new Date(),
      required: true,
      gridClass: "col-lg-2",
    },
    {
      name: "city_id",
      label: "City",
      placeholder: "Select City",
      type: "dropdown",
      options: city,
      required: true,
      gridClass: "col-lg-2",
    },
  ];

  const handleKeyPress = (e) => {
    console.log("keyname", e.key);

    if (e.key === "Enter") {
      fetchDealerBranches(0, 10, searchTerm);
    }
  };
  const clearSearchAndFetch = () => {
    setSearchTerm("");
  };
  useEffect(() => {
    if (searchTerm === "") {
      fetchDealerBranches({ searchText: "" });
    }
  }, [searchTerm]);

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <div>
          <div className="OnboardManagamentContainer row">
            <div className="OnboardManagamentbuttonContainer col-xl-6 col-lg-12 mt-2 mb-2">
              <h5>Dealer Branch Management</h5>
            </div>
            <div className="totalvaluescontainer col-xl-6 col-lg-12 mt-2 mb-2">
              <div
                className="topleftdataContainer"
                style={{ borderRight: "1px solid lightgrey" }}
              >
                <h5 className="listTopDataValueText">{totalData} </h5>
                <h6>All Dealers Branch</h6>
              </div>
              <div
                className="topleftdataContainer"
                style={{ borderRight: "1px solid lightgrey" }}
              >
                <h5 className="listTopDataValueText">{totalActive} </h5>
                <h6>Active Branches</h6>
              </div>
              <div
                className="topleftdataContainer"
                style={{ borderRight: "1px solid lightgrey" }}
              >
                <h5 className="listTopDataValueText">{totalInactive} </h5>
                <h6>Inactive Branches</h6>
              </div>
              {/* <div className="topleftdataContainer">
                <h5 className="listTopDataValueText">{revenue} </h5>
                <h6>Annual Revenue</h6>
              </div> */}
              <div>
                <button
                  className="addcustomerbutton"
                  onClick={() => navigate(ROUTES_NAVIGATION.ADDDEALERBRANCH)}
                >
                  Add Dealer Branch
                </button>
              </div>
            </div>
          </div>

          {/* <ListFilters city={city} clearSearch={clearFilter} handleSearch={handleSearch} /> */}

          <ListLogisticsFilters
            formConfig={PhysicalStockTakingInputs}
            formData={filterFormData}
            setFormData={setFilterFormData}
            validationErrors={validationErrors}
            setValidationErrors={setValidationErrors}
            // onSubmit={handleFormSubmit}
            handleSearch={handleSearch}
            handleClear={clearFilter}
          />

          <div className="tableWrapper">
            <div className="admin-list-container">
              <div className="listsearchContainer">
                <h5>Dealer Branches List</h5>
                <div className="searchinput-wrapper">
                  <input
                    type="text"
                    className="searchinput"
                    placeholder="Search by Dealer Branch"
                    value={searchTerm}
                    onChange={handleSearchInputChange}
                    onKeyDown={handleKeyPress}
                  />
                  {searchTerm ? (
                    <IoMdClose
                      size={22}
                      className="searchinput-close-icon"
                      onClick={clearSearchAndFetch}
                    />
                  ) : (
                    <img
                      src={searchIcon}
                      alt="Search"
                      className="searchinput-icon"
                    />
                  )}
                </div>
              </div>
              {/* <div className='downloadiconwrapper'>
            <h6 className='downloadTitle'>Download</h6>
            <img src={downloadIcon} alt='download' onClick={handleDownloadClick} style={{ cursor: 'pointer' }} />
          </div> */}
            </div>

            <CustomTable
              data={dealerBranches}
              headers={DEALER_BRANCH_TABLE_HEADERS}
              keyMapping={DEALER_BRANCH_KEY_MAPPING}
              itemsPerPage={10}
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
              onEdit={handleEdit}
              totalRecords={totalRecords}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DealerBranchList;
